import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import { AuthContext } from "../../context/AuthContext";
import { GOOGLE_CLIENT_ID, googleYukle } from "./uyeApi";
import "./uye.css";

/**
 * "Google ile devam et" (giriş = kayıt). Alarm / favori düğmesine basan üye değilse açılır; giriş olunca onGiris.
 * Aydınlatma metni bilgilendirmedir (onay kutusu değil); pazarlama e-postası için ayrı, isteğe bağlı açık rıza.
 */
const DONUS_ANAHTARI = "iu_giris_oncesi";

/** Giriş sayfasına gitmeden önce bulunulan sayfayı hatırla (header "Giriş yap"); giriş bitince oraya dönülür. */
export function girisOncesiniHatirla() {
  try {
    const yol = window.location.pathname + window.location.search;
    if (!/^\/(login|signup)/.test(window.location.pathname)) sessionStorage.setItem(DONUS_ANAHTARI, yol);
  } catch (e) { /* özel sekme vb. */ }
}

/** Girişten sonra dönülecek adres: giriş öncesi sayfa, yoksa ana sayfa. */
export function girisSonrasiAdres() {
  try {
    const yol = sessionStorage.getItem(DONUS_ANAHTARI);
    sessionStorage.removeItem(DONUS_ANAHTARI);
    if (yol && yol.startsWith("/")) return yol;
  } catch (e) { /* özel sekme vb. */ }
  return "/";
}

export function GoogleGiris({ onGiris }) {
  const { googleGiris } = useContext(AuthContext);
  const kutu = useRef(null);
  const izinRef = useRef(false);
  const [izin, setIzin] = useState(false);
  const [hata, setHata] = useState("");
  const [bekle, setBekle] = useState(false);
  const [uzun, setUzun] = useState(false); // 6 sn'yi geçti: Azure soğuk açılıyor olabilir

  useEffect(() => {
    if (!bekle) { setUzun(false); return undefined; }
    const z = setTimeout(() => setUzun(true), 6000);
    return () => clearTimeout(z);
  }, [bekle]);

  useEffect(() => { izinRef.current = izin; }, [izin]);

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID) return;
    let iptal = false;
    googleYukle().then((g) => {
      if (iptal || !kutu.current) return;
      g.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: (yanit) => {
          setBekle(true);
          setHata("");
          googleGiris(yanit.credential, izinRef.current,
            () => { setBekle(false); onGiris && onGiris(); },
            (m) => { setBekle(false); setHata(String(m)); });
        },
      });
      g.accounts.id.renderButton(kutu.current, { theme: "outline", size: "large", text: "continue_with", shape: "pill", locale: "tr", width: 280 });
    }).catch(() => setHata("Google'a bağlanılamadı. Kullanıcı adıyla giriş yapabilirsin."));
    return () => { iptal = true; };
  }, []);

  return (
    <div className="uy-google">
      {GOOGLE_CLIENT_ID
        ? <div ref={kutu} className="uy-google-dugme" />
        : <p className="uy-not">Google ile giriş yakında. Şimdilik <Link to="/login">kullanıcı adıyla giriş</Link> yapabilirsin.</p>}
      {bekle && (
        // tüm sayfayı kaplar: giriş sürerken alttaki form / düğmeler kullanılmasın
        <div className="uy-giris-perde" role="status" aria-live="polite">
          <div className="uy-giris-kutu"><span className="uy-donen" aria-hidden="true" />Google hesabınla giriş yapılıyor…
            {uzun && <small className="uy-giris-uzun">Sunucu uyanıyor, birkaç saniye daha…</small>}</div>
        </div>
      )}
      {hata && <p className="uy-hata">{hata}</p>}
      <label className="uy-izin">
        <input type="checkbox" checked={izin} onChange={(e) => setIzin(e.target.checked)} />
        <span>Kampanya ve haftalık indirim özeti e-postaları almak istiyorum (isteğe bağlı).</span>
      </label>
      <p className="uy-kucuk">
        Devam ederek <Link to="/aydinlatma-metni/">Aydınlatma Metni</Link>'ni okuduğunu kabul edersin. E-posta adresin
        yalnızca alarm ve favori bildirimleri için kullanılır.
      </p>
    </div>
  );
}

export default function GirisPenceresi({ acik, kapat, baslik = "Giriş yap", aciklama, onGiris }) {
  useEffect(() => {
    if (!acik) return undefined;
    const tus = (e) => { if (e.key === "Escape") kapat(); };
    window.addEventListener("keydown", tus);
    return () => window.removeEventListener("keydown", tus);
  }, [acik]);
  if (!acik) return null;
  return (
    <div className="uy-perde" onClick={kapat} role="presentation">
      <div className="uy-pencere" role="dialog" aria-modal="true" aria-label={baslik} onClick={(e) => e.stopPropagation()}>
        <button type="button" className="uy-kapat" onClick={kapat} aria-label="Kapat">×</button>
        <div className="uy-ikon" aria-hidden="true">🔔</div>
        <h2>{baslik}</h2>
        {aciklama && <p className="uy-aciklama">{aciklama}</p>}
        <GoogleGiris onGiris={() => { onGiris && onGiris(); }} />
        <p className="uy-alt">Hesabın kullanıcı adıyla mı? <Link to="/login">Buradan giriş yap</Link></p>
      </div>
    </div>
  );
}
